import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4364f93e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Crea estos parámetros en el caso de ser necesario.", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " El archivo no se puede subir porque los siguientes parámetros no tienen un rango físico definido. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    (
        !_ctx.alert &&
        _ctx.headerParameter &&
        _ctx.headerParameter.length > 0 &&
        (!_ctx.parametersWithoutRange || _ctx.parametersWithoutRange.length === 0)
      )
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          type: "info",
          "show-icon": "",
          closable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("info.infoUpload")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerParameter, (item) => {
              return (_openBlock(), _createBlock(_component_el_row, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" - " + _toDisplayString(item.code), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.paramsNotFound && _ctx.paramsNotFound.length > 0)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 1,
          type: "warning",
          "show-icon": "",
          closable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("error.paramsNotFound")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramsNotFound, (item) => {
              return (_openBlock(), _createBlock(_component_el_row, { key: item }, {
                default: _withCtx(() => [
                  _createTextVNode(" - " + _toDisplayString(item), 1)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.parametersWithoutRange && _ctx.parametersWithoutRange.length > 0)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 2,
          type: "error",
          "show-icon": "",
          closable: false
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametersWithoutRange, (item) => {
              return (_openBlock(), _createBlock(_component_el_row, { key: item }, {
                default: _withCtx(() => [
                  _createTextVNode(" - " + _toDisplayString(item), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}